import { render, staticRenderFns } from "./TreeHistory.vue?vue&type=template&id=64f91824&scoped=true"
import script from "./TreeHistory.vue?vue&type=script&lang=js"
export * from "./TreeHistory.vue?vue&type=script&lang=js"
import style0 from "./TreeHistory.vue?vue&type=style&index=0&id=64f91824&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f91824",
  null
  
)

export default component.exports